import ListingQueue from './ListingQueue';

export default ListingQueue;
